import { LoaderFunctionArgs } from 'react-router-dom';
import { queryKeysClient } from 'common/clients/query-key.client.ts';
import { queryClient } from 'common/clients/query.client.ts';
import { EQueryKeys } from 'common/enums/query-keys.enums.ts';
import { EUrlQueryParams } from 'common/enums/url-query-params.enums.ts';
import { captureError, IError } from 'common/utils/error.utils.ts';
import { EMode } from 'domains/on-off-ramp/enums/on-off-ramp.enums.ts';
import { IOrderRampRes } from 'domains/on-off-ramp/interfaces/on-off-ramp.interfaces.ts';
import { IRampPageLoaderData } from 'pages/ramp/interfaces/ramp.interfaces.ts';

const ISO_ALPHA_2_REGEXP = /^[a-zA-Z]{2}$/;

const getBeThemeQueryParamValue = (rawTheme: string): string => {
  if (rawTheme === 'dark') {
    return 'dark';
  }

  if (rawTheme === 'light' || rawTheme === 'white') {
    return 'white';
  }

  return '';
};

export const rampPageLoader = async ({ request }: LoaderFunctionArgs): Promise<IRampPageLoaderData | Response> => {
  try {
    const url = new URL(request.url);
    const { searchParams } = url;
    const modeQueryParamValue = searchParams.get(EUrlQueryParams.Mode) ?? '';
    const cryptoMethodGuidQueryParamValue = searchParams.get(EUrlQueryParams.CryptoMethodGuid) ?? '';
    const amountQueryParamValue = searchParams.get(EUrlQueryParams.Amount) ?? '';
    const paymentCurrencyQueryParamValue = searchParams.get(EUrlQueryParams.PaymentCurrency) ?? '';
    const cryptoCurrencyQueryParamValue = searchParams.get(EUrlQueryParams.CryptoCurrency) ?? '';
    const countryQueryParamValue = searchParams.get(EUrlQueryParams.Country) ?? '';
    const themeQueryParamValue = getBeThemeQueryParamValue(searchParams.get(EUrlQueryParams.Theme) ?? '');
    const isCountryQueryParamValueValid = ISO_ALPHA_2_REGEXP.test(countryQueryParamValue);

    const getOrderRampQuery = queryKeysClient[EQueryKeys.OnOffRamp].getOrderRampData({
      ...(modeQueryParamValue ? { mode: modeQueryParamValue } : {}),
      ...(cryptoMethodGuidQueryParamValue ? { crypto_method_guid: cryptoMethodGuidQueryParamValue } : {}),
      ...(amountQueryParamValue ? { amount: amountQueryParamValue } : {}),
      ...(paymentCurrencyQueryParamValue ? { payment_currency: paymentCurrencyQueryParamValue } : {}),
      ...(cryptoCurrencyQueryParamValue ? { crypto_currency: cryptoCurrencyQueryParamValue } : {}),
      ...(isCountryQueryParamValueValid ? { country: countryQueryParamValue.toUpperCase() } : {}),
      ...(themeQueryParamValue ? { theme: themeQueryParamValue } : {}),
    });
    const orderRampData: IOrderRampRes =
      await queryClient.getQueryData(getOrderRampQuery.queryKey)
      ?? await queryClient.fetchQuery(getOrderRampQuery);

    return {
      orderRampData,
      mode: modeQueryParamValue as EMode,
      country: isCountryQueryParamValueValid ? countryQueryParamValue.toUpperCase() : '',
    };
  } catch (e: unknown) {
    const error = e as {
      response: {
        status: number;
      }
    };

    captureError(error as IError);

    return {
      orderRampData: {
        url: 'https://aps.money',
      },
      mode: '',
      country: '',
    };
  }
};
